import Vue from 'vue'
import Router from 'vue-router'

// Components
import Index from '@/components/Index/Index'
import SteamLogin from '@/components/SteamLogin'
import Dashboard from '@/components/Dashboard'
import Donate from '@/components/Donate'
import FAQ from '@/components/FAQ'
import Success from '@/components/Success'
import History from '@/components/History'

// Admin
import Admin from '@/components/Admin/Admin'
import AdminUserEdit from '@/components/Admin/User/Edit'
import AdminUserCreate from '@/components/Admin/User/Create'

// User Api
import UserApi from '@/services/UserApi'

// Vuex
import store from '../store'

Vue.use(Router)

// Define Routes
let router = new Router({
  mode: 'history',
  routes: [
  {
    path: '/',
    name: 'index',
    component: Index
  },
  {
    path: '/login',
    name: 'login',
    component: SteamLogin,
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/donate/:plan_id',
    name: 'donate',
    component: Donate,
    props: true,
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/faq',
    name: 'faq',
    component: FAQ,
    props: true,
  },
  {
    path: '/success',
    name: 'success',
    component: Success,
    meta: {
      requiresAuth: true
    },
    beforeEnter: (to, from, next) => {
      if(!store.getters['user/getPaymentSuccess']) {

        next({
          path: '/',
          params: { nextUrl: to.fullPath }
        })
      } else {
        store.commit('user/setPaymentSuccess', false);
        next();
      }
    }
  },
  {
    path: '/history',
    name: 'History',
    component: History
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin,
    meta: {
      requiresAdmin: true
    },
  },
  {
    path: '/admin/user/create',
    name: 'Admin Create User',
    component: AdminUserCreate,
    meta: {
      requiresAdmin: true
    },
  },
  {
    path: '/admin/user/:id/edit',
    name: 'Admin Edit User',
    component: AdminUserEdit,
    meta: {
      requiresAdmin: true
    },
  }
  ]
})

/*router.redirect({
  '*': '/'
})*/

// Router authentication logic
router.beforeEach((to, from, next) => {

  if(to.meta.requiresAuth) {
    UserApi.getData().then(user => {
      // Client logged in
      next()
    }).catch(error => {
      // Client not logged in
      next({
        path: '/login',
        params: { nextUrl: to.fullPath }
      })
    })
  }

  if(to.meta.requiresAdmin) {
    UserApi.getData().then(user => {
      // Client is an admin
      if(user.is_admin) {
        next()
      } else {
        next({
          path: '/',
          params: { nextUrl: to.fullPath }
        })
      }
    }).catch(error => {
      // Client not not an admin
      next({
        path: '/',
        params: { nextUrl: to.fullPath }
      })
    })
  }

  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js